import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ColorPickerListItem from '../../../../../../list-items/ColorPickerListItem/ColorPickerListItem';

const VisualizerShadowColorListItem = (props) => {
    const { dropShadowSettingsColor, updateVisualizerSettings } = props;
    
    const onShadowColorChange = (color) => {
        var value = color.hex.replace('#', '0x');

        updateVisualizerSettings({ 
            dropShadowSettings: { color: value } 
        });
    };
    
    return (
        <ColorPickerListItem
            text='Color'
            color={dropShadowSettingsColor.replace('0x', '#')}
            onChange={onShadowColorChange}
            disableAlpha={true}
        />
    );
};

const mapStateToProps = (state) => {
    const { color: dropShadowSettingsColor } = state.createPreview.present.videoSettings.visualizer.dropShadowSettings;
    return { dropShadowSettingsColor };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShadowColorListItem);